import React, { useEffect, useState } from "react";
import { Layout, Space, ConfigProvider } from "antd";
import { useLocation, Outlet, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setJourneyIsCollection } from "../../redux/features/content_library/contentLibrarySlice";
import { setIsCollectionCL } from "../../redux/features/main/searchSlice";
import HeaderContent from "../../components/Header/index";
import useActions from "./hooks/useActions";
import SnackBar from "../../components/SnackBar";
import SnackBarRedeem from "../../components/SnackBarRedeem";
import ModalOnboarding from "../../components/ModalOnboarding";
import ModalRating from "../../components/ModalRating";
import ModalNotifNewProgram from "../../components/ModalNotifNewProgram";
import ModalNotifNewCL from "../../components/ModalNotifNewCL";
import ModalUpcomingEventDetail from "../main/contents/Home/elements/UpcomingEvents/component/ModalUpcomingEventDetail";
import ModalInvalidToken from "../../components/ModalInvalidToken";

import { useSelector } from "react-redux";
import { getLocalStorage, lanSetting } from "../../utils";

// for translate
import { useTranslation } from "react-i18next";

import Search from "../filter/Search/index";
import CategoryAll from "../filter/CategoryAll/index";

const { Header, Content } = Layout;

import Sidebar from "../../components/Sidebar/index";
import SidebarMobile from "../../components/Sidebar/mobileVersion/index";

// color config
import {
  textTitleHome,
  ColorPrimary,
  ColorPrimaryBtnHover,
  ColorSecondary,
  ColorSecondaryHover,
  ColorTertiariHover,
  textTitleDesc,
  textMenu,
  backgroundDisabledButton,
  slickThumbColor,
  homeBackground,
  dividerListCourseColor,
  dividerListModuleColor,
  progressLineListModuleColor,
  colorAlertRedDark,
  colorHoverRed,
  colorTransparentBackgroundGrey,
  colorTextTitle,
  colorLink,
  colorPrimarySoft,
  linkHover,
  colorTextDesc,
  colorBodyRating,
  greyFormInput,
  colorTextList,
  NavHomeSwiper,
  backgroundLinear1,
  backgroundLinear2,
  whiteColor,
  whiteCream,
  colorBorderErrorInputForm,
  whiteSoft,
  ColorTertiari,
} from "../../config/constant/color/index";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";

// set root css variable
document.documentElement.style.setProperty("--primary-bg-color", ColorPrimary);
document.documentElement.style.setProperty("--primary-bg-border", ColorPrimary);
document.documentElement.style.setProperty(
  "--secondary-bg-border",
  ColorPrimary,
);
document.documentElement.style.setProperty(
  "--primary-bg-hover",
  ColorPrimaryBtnHover,
);
document.documentElement.style.setProperty(
  "--secondary-bg-color",
  ColorSecondary,
);
document.documentElement.style.setProperty(
  "--secondary-bg-hover",
  ColorSecondaryHover,
);
document.documentElement.style.setProperty(
  "--tertieri-bg-hover",
  ColorTertiariHover,
);
document.documentElement.style.setProperty("--grey-hard", textTitleHome);
document.documentElement.style.setProperty(
  "--grey-soft",
  backgroundDisabledButton,
);
document.documentElement.style.setProperty("--slick-thumb", slickThumbColor);
document.documentElement.style.setProperty("--divider", dividerListCourseColor);
document.documentElement.style.setProperty(
  "--divider--listmodule",
  dividerListModuleColor,
);
document.documentElement.style.setProperty(
  "--step--listmodule",
  progressLineListModuleColor,
);
document.documentElement.style.setProperty(
  "--remove--collection",
  colorAlertRedDark,
);
document.documentElement.style.setProperty(
  "--remove--collection-hover",
  colorHoverRed,
);
document.documentElement.style.setProperty(
  "--grey-soft",
  colorTransparentBackgroundGrey,
);
document.documentElement.style.setProperty("--text-black", colorTextTitle);
document.documentElement.style.setProperty("--blue-link", colorLink);
document.documentElement.style.setProperty("--primary-soft", colorPrimarySoft);
document.documentElement.style.setProperty("--link-hover", linkHover);
document.documentElement.style.setProperty("--grey-too", colorTextDesc);
document.documentElement.style.setProperty("--rating-text", colorBodyRating);
document.documentElement.style.setProperty("--grey-form", greyFormInput);
document.documentElement.style.setProperty("--grey-more", colorTextList);
document.documentElement.style.setProperty("--swiper-home", NavHomeSwiper);
document.documentElement.style.setProperty(
  "--bg-gradient-1",
  backgroundLinear1,
);
document.documentElement.style.setProperty(
  "--bg-gradient-2",
  backgroundLinear2,
);
document.documentElement.style.setProperty("--white-cream", whiteCream);
document.documentElement.style.setProperty(
  "--red-dark",
  colorBorderErrorInputForm,
);
document.documentElement.style.setProperty("--white-shoft", whiteSoft);
document.documentElement.style.setProperty("--green-border", ColorTertiari);

const Main = ({ mainContent, isMobileVersion }) => {
  const dispatch = useDispatch();
  const userId = useSelector((state) => state.localization.userId);
  const isInvalidToken = useSelector((state) => state.invalidT.isInvalidToken);

  const { t, i18n } = useTranslation();

  const location = useLocation();

  const [popupStream, setPopupStream] = useState({
    status: false,
    url: "",
  });
  const [reFetchJourney, setRefetchJourney] = useState(false);
  const [trigerFetch, setTrigerFetch] = useState(false);
  const [defaultKeyListCourse, setDefaultKeyListCourse] = useState(null);
  const [trigerExitModule, setTrigerExitModule] = useState(false);
  const [currModuleExit, setCurrModuleExit] = useState();

  // state for refetch Left Section of Learning Pages (List Course, List Module, Program Desc)
  const [reFetchLeftSection, setRefetchLeftSection] = useState(false);

  const [getLastModule, setLastModule] = useState();
  const [getLastModuleSupport, setLastModuleSupport] = useState();
  const [moduleTargetedComplete, setModuleTargetedComplete] = useState();
  const [completion, setCompletion] = useState(false);
  const [messageSnack, setMessageSnack] = useState("");
  const [openSnack, setOpenedSnack] = useState(false);
  const [academyNameHeader, setAcademyNameHeader] = useState();
  const [currAcademy, setCurrAcademy] = useState();

  let [searchParams, setSearchParams] = useSearchParams();
  const [isOnSearchPage, setIsOnSearchPage] = useState(false);
  const [isOnDetailSearch, setIsOnDetailSearch] = useState(false);
  const [invalidTokenPopup, setInvalidTokenPopup] = useState(false);
  const [isFocusedSearch, setIsFocusedSearch] = useState(false);

  //kebutuhan back di mobile version
  const [urlBack, _setUrlBack] = useState("");

  const setUrlBack = (url) => {
    _setUrlBack(url);
  };

  const {
    loading,
    userData,
    totalJourney,
    totalJourneyCompleted,
    allJourneyData,
    listJourney,
    listCourse,
    flagUpdatePicture,
    hasRating,
    isSubmit,
    isCompleted,
    pointClaimed,
    badgesState,
    setFlagUpdatePicture,
    checkHasRating,
    setHasRating,
    setIsSubmit,
    setIsCompleted,
    setPointClaimed,
    setBagdesState,
    fetchUserProfile,
    checkCompletion,
    isFetchRating,
    setIsFetchRating,
  } = useActions(
    moduleTargetedComplete,
    setCompletion,
    getLastModule,
    getLastModuleSupport,
    trigerFetch,
    currModuleExit,
    setTrigerFetch,
    setRefetchJourney,
    setTrigerExitModule,
    reFetchLeftSection,
    setRefetchLeftSection,
  );

  const mainState = {
    popupStream,
    setPopupStream,
    reFetchJourney,
    setRefetchJourney,
    trigerFetch,
    setTrigerFetch,
    flagUpdatePicture,
    setFlagUpdatePicture,
    defaultKeyListCourse,
    setDefaultKeyListCourse,
    trigerExitModule,
    setTrigerExitModule,
    setCurrModuleExit,
    reFetchLeftSection,
    setRefetchLeftSection,
    setLastModule,
    setLastModuleSupport,
    setCompletion,
    setModuleTargetedComplete,
    messageSnack,
    setMessageSnack,
    openSnack,
    setOpenedSnack,
    setAcademyNameHeader,
    currAcademy,
    setCurrAcademy,
    setIsFetchRating,
    urlBack,
    setUrlBack,
    setIsFocusedSearch,
    isFocusedSearch,
    completion,
  };

  useEffect(() => {
    // if(trigerExitModule === true) checkHasRating();
  }, [trigerExitModule]);

  useEffect(() => {
    if (completion === true) checkCompletion();
  }, [completion]);

  useEffect(() => {
    if (reFetchJourney === true) fetchUserProfile();
  }, [reFetchJourney]);

  useEffect(() => {
    if (location.pathname === "/team-monitoring/event/detail") {
      document.body.classList.add("on-calendar");
    } else {
      document.body.classList.remove("on-calendar");
    }

    const url = window.location.pathname;
    const arrId = url.split("/");
    if (url.indexOf("content-library/academy") > -1 && arrId.length !== 6) {
      dispatch(setJourneyIsCollection(-1));
    }

    // for search bar Content Library purpose
    dispatch(setIsCollectionCL(false));

    // if (isMobileVersion) {
    //   if (url.indexOf("content-library/academy") > -1) {
    //     setUrlBack("/content-library");
    //   } else if (url.indexOf("my-learning-journey") > -1) {
    //     setUrlBack("/my-learning-journey");
    //   } else if (url.indexOf("team-monitoring") > -1) {
    //     setUrlBack("/team-monitoring");
    //   } else if (url.indexOf("home") > -1) {
    //     setUrlBack("/home");
    //   }
    // }
  }, [location]);

  // useEffect for checking if the page was on search state
  useEffect(() => {
    if (
      searchParams.get("search") !== undefined &&
      searchParams.get("search") !== "" &&
      searchParams.get("search") !== null
    ) {
      setIsOnSearchPage(true);
      if (
        searchParams.get("all") !== undefined &&
        searchParams.get("all") !== "" &&
        searchParams.get("all") !== null
      ) {
        setIsOnDetailSearch(true);
      } else {
        setIsOnDetailSearch(false);
      }
    } else {
      setIsOnSearchPage(false);
      setIsOnDetailSearch(false);
    }
  }, [searchParams]);

  useEffect(() => {
    const userIdLocal = getLocalStorage(lanSetting.user_id);
    const lanConst = getLocalStorage(lanSetting.lan_set);
    let jsonGet =
      Array.isArray(lanConst) === true ? lanConst : JSON.parse(lanConst);
    let currLang = "en";

    if (jsonGet.length > 0) {
      for (var i = 0; i < jsonGet.length; i++) {
        if (jsonGet[i][lanSetting.user_id] === parseInt(userIdLocal)) {
          currLang = jsonGet[i][lanSetting.lan];
        }
      }
      i18n.changeLanguage(currLang);
    }
  }, [userId]);

  useEffect(() => {
    if (isInvalidToken === 498) setInvalidTokenPopup(true);
  }, [isInvalidToken]);

  const screens = useBreakpoint();

  //validate header hidden on mobile
  const locPathname = location.pathname;
  const journeyId = locPathname.split("/")[3];
  const courseId = locPathname.split("/")[5];
  const modulId = locPathname.split("/")[7];
  const headerMobileInVisible =
    locPathname.includes("/content-library/academy") ||
    (locPathname.includes("my-learning-journey") &&
      !!(
        (locPathname === courseId &&
          `/my-learning-journey/journey/${journeyId}/course/${courseId}`) ||
        (journeyId && `/my-learning-journey/journey/${journeyId}`)
      ));

  const isModulPage =
    locPathname ===
    `/my-learning-journey/journey/${journeyId}/course/${courseId}/module/${modulId}`;

  const isContentLibraryPage =
    locPathname === `/content-library` ||
    locPathname === `/my-learning-journey`;

  const isPageDetailCalenderEvent =
    locPathname === "/team-monitoring/event/detail";

  const headerWithoutHamburger =
    locPathname.includes("/team-monitoring/learning-status/detail") ||
    locPathname.includes("/team-monitoring/journey/") ||
    locPathname.includes("/team-monitoring/team-profile");

  const headerReviewModule = locPathname.includes("/reviews/module");

  const renderHeader = () => {
    if (isMobileVersion) {
      if (headerMobileInVisible) return null;
      else {
        return (
          <Header
            className="text-center"
            style={{
              height: isContentLibraryPage ? "62px" : "68px",
              lineHeight: "64px",
              border:
                isContentLibraryPage ||
                isPageDetailCalenderEvent ||
                headerWithoutHamburger ||
                headerReviewModule ||
                locPathname.includes("/team-monitoring/member/profile")
                  ? "none"
                  : "1px solid #E5E5E6",
              padding: "0 24px 0 0",
              backgroundColor:
                (headerWithoutHamburger && "#FFF9F6") ||
                (headerReviewModule && "#FFFFFF"),
            }}
          >
            <HeaderContent
              name={userData.userName}
              position={userData.userPosition}
              points={userData.learningPoints}
              picture={userData.picture}
              firstname={userData.firstname}
              loadingHeader={loading}
              listJourney={listJourney}
              academyNameHeader={academyNameHeader}
              mainState={mainState}
            />
          </Header>
        );
      }
    } else {
      return (
        <Header
          className="text-center"
          style={{
            height: "68px",
            lineHeight: "64px",
            border: "1px solid #E5E5E6",
            padding: "0 40px 0 64px",
            zIndex: 99,
          }}
        >
          <HeaderContent
            name={userData.userName}
            position={userData.userPosition}
            points={userData.learningPoints}
            picture={userData.picture}
            firstname={userData.firstname}
            loadingHeader={loading}
            listJourney={listJourney}
            academyNameHeader={academyNameHeader}
            mainState={mainState}
          />
        </Header>
      );
    }
  };

  return (
    <div>
      <ConfigProvider
        theme={{
          components: {
            Layout: {
              headerBg: "#FFFFFF",
              headerColor: textTitleDesc,
              headerPadding: "0 60px 0 64px",
              siderBg: "#FFFFFF",
              bodyBg: homeBackground,
              triggerColor: textTitleHome,
              triggerBg: "#FFFFFF",
            },
            Menu: {
              itemSelectedColor: ColorPrimary,
              itemSelectedBg: "#FFFFFF",
              itemHoverBg: "#FFFFFF",
              itemHoverColor: ColorPrimary,
              itemColor: textMenu,
              itemBorderRadius: 0,
              itemMarginInline: 0,
              collapsedIconSize: 18,
              iconSize: 18,
            },
            List: {
              descriptionFontSize: 100,
              contentWidth: 100,
              avatarMarginRight: 10,
              itemPadding: "10px 0",
            },
          },
        }}
      >
        <Space
          direction="vertical"
          style={{
            width: "100%",
            height: "100vh",
          }}
        >
          <Layout style={{ height: "100%" }}>
            {renderHeader()}
            <Layout hasSider>
              {isMobileVersion ? (
                <SidebarMobile
                  mainState={mainState}
                  userData={userData}
                  listJourney={listJourney}
                />
              ) : (
                <Sidebar
                  mainState={mainState}
                  userData={userData}
                  listJourney={listJourney}
                />
              )}

              <Content
                className="text-center"
                id="content-main"
                style={{
                  marginLeft: isMobileVersion ? "unset" : 64,
                  minHeight: 120,
                  lineHeight: "120px",
                  // overflowY: isMobileVersion
                  //   ? isContentLibraryPage
                  //     ? "hidden"
                  //     : "auto"
                  //   : "scroll",
                  overflowY: isMobileVersion
                    ? isPageDetailCalenderEvent || headerWithoutHamburger
                      ? "hidden"
                      : "auto"
                    : "auto",
                  color: textTitleDesc,
                  overflowX: isMobileVersion ? "hidden" : "unset",
                  backgroundColor:
                    isMobileVersion && (isModulPage || headerWithoutHamburger)
                      ? whiteColor
                      : "unset",
                }}
              >
                {/* passing props to children props */}
                {!isOnSearchPage ? (
                  <Outlet
                    context={[
                      loading,
                      userData,
                      totalJourney,
                      totalJourneyCompleted,
                      allJourneyData,
                      listJourney,
                      listCourse,
                      mainState,
                    ]}
                  />
                ) : !isOnDetailSearch ? (
                  // <Search />
                  // add props to get all journey data for card search journey in mobile
                  <Search
                    allJourneyData={allJourneyData}
                    loadingAllJourney={loading}
                    isMobileVersion={isMobileVersion}
                    isContentLibraryPage={isContentLibraryPage}
                    mainState={mainState}
                  />
                ) : (
                  <CategoryAll
                    isMobileVersion={isMobileVersion}
                    isContentLibraryPage={isContentLibraryPage}
                  />
                )}
                {/* {React.cloneElement(mainContent, {
                load: loading,
                userDataMain: userData, 
                totalJourneyMain: totalJourney, 
                totalJourneyCompletedMain: totalJourneyCompleted, 
                allJourneyDataMain: allJourneyData,
                listJourneyMain: listJourney,
                listCourseMain: listCourse
              })} */}
              </Content>
            </Layout>
          </Layout>
        </Space>

        <ModalRating
          hasRating={hasRating}
          isSubmit={isSubmit}
          isCompleted={isCompleted}
          pointClaimed={pointClaimed}
          badgesState={badgesState}
          currModuleExit={currModuleExit}
          trigerExitModule={trigerExitModule}
          setHasRating={setHasRating}
          setIsSubmit={setIsSubmit}
          setIsCompleted={setIsCompleted}
          setPointClaimed={setPointClaimed}
          setBagdesState={setBagdesState}
          setTrigerExitModule={setTrigerExitModule}
          isFetchRating={isFetchRating} // state proccess fetch rating, badges, claimed point
          mainState={mainState}
        />

        <ModalNotifNewProgram />
        <ModalNotifNewCL />

        <SnackBar
          messageSnack={messageSnack}
          openSnack={openSnack}
          setOpenedSnack={setOpenedSnack}
          isMobileVersion={isMobileVersion}
        />
        <SnackBarRedeem />

        <ModalOnboarding />
        <ModalUpcomingEventDetail isMobileVersion={isMobileVersion} />
        <ModalInvalidToken
          invalidTokenPopup={invalidTokenPopup}
          setInvalidTokenPopup={setInvalidTokenPopup}
        />
      </ConfigProvider>
    </div>
  );
};

Main.propTypes = {};

Main.defaultProps = {};

export default Main;
